/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Hospital from './hospital';
import HospitalDetail from './hospital-detail';
import HospitalUpdate from './hospital-update';
import HospitalDeleteDialog from './hospital-delete-dialog';

const HospitalRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Hospital />} />
    <Route path="new" element={<HospitalUpdate />} />
    <Route path=":id">
      <Route index element={<HospitalDetail />} />
      <Route path="edit" element={<HospitalUpdate />} />
      <Route path="delete" element={<HospitalDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HospitalRoutes;
